<template>
  <div class="table-width">
    <cTable
      :fields="fields"
      :modals="modals"
      :methods="methods"
      :footer="footer"
      :config="config"
      ref="table"
    >
    </cTable>
  </div>
</template>
<script>
import cTable from "@/base/common/index";
export default {
  props: {
    row: Array
  },
  components: {
    cTable
  },
  mounted() {
    this.$refs.table.list = this.row;
  },
  data() {
    return {
      config: {
        resize: false,
        slot: "div"
      },
      methods: {},
      footer: {
        show: () => false
      },
      modals: {},
      fields: [
        {
          name: () => "FBA" + this.$t("cargo_number"),
          minWidth: 100,
          key: "product_code"
        },
        {
          name: () => this.$t("trackingNumber"),
          minWidth: 100,
          key: "track_code"
        },
        {
          name: () => this.$t("deliveryAddress"),
          key: "warehouse",
          minWidth: 100
        },
        {
          name: () => this.$t("delivery") + this.$t("date"),
          key: "deliver_date",
          minWidth: 100
        },
        {
          name: () => this.$t("delivery") + this.$t("time"),
          key: "deliver_time",
          minWidth: 100
        },
        {
          name: () => this.$t("invoicePCS"),
          key: "ctns",
          minWidth: 100
        },
        {
          name: () => this.$t("invoiceWeight"),
          key: "pcs",
          minWidth: 150
        }
      ]
    };
  }
};
</script>
<style>
.table-width {
  width: 1200px;
  overflow: hidden;
}
.vxe-body--expanded-cell {
  background: #f5f5f5;
  padding: 20px 0;
}
</style>
